import { postClaimSearch, } from '@zurich/api/search';
import { useIndexSearch } from './useIndexSearch';
export function useClaimSearch(options) {
    return useIndexSearch({
        request: postClaimSearch,
        suggestions: options?.suggestions,
    });
}
